/**
 * 🏪 TIER 7 BUILDINGS - Commerce & Trade
 * 
 * Unlocked by: Commerce, Trade Routes, Sailing, Banking
 * Cost multiplier: 244x | Prod multiplier: 16.8x
 * Costs: 12,000-35,000 | Production: 6-10/s
 * Target ROI: ~12 minutes
 */

export const TIER_07_BUILDINGS = {
  tradingPost: {
    id: 'tradingPost',
    name: 'Trading Post',
    icon: '🏬',
    tier: 7,
    description: 'Facilitates long-distance trade',
    flavor: 'Goods from far and wide.',
    baseCost: { wood: 18000, stone: 14400, gold: 9600 },
    baseProduction: { gold: 8.5 },
    unlockCondition: { tech: 'commerce' },
  },

  harbor: {
    id: 'harbor',
    name: 'Harbor',
    icon: '⚓',
    tier: 7,
    description: 'Enables sea trade',
    flavor: 'Ships bring wealth from distant shores.',
    baseCost: { wood: 22400, stone: 17600, gold: 12000 },
    baseProduction: { gold: 10.0, food: 3.5 },
    unlockCondition: { tech: 'sailing' },
  },

  bank: {
    id: 'bank',
    name: 'Bank',
    icon: '🏦',
    tier: 7,
    description: 'Manages and multiplies wealth',
    flavor: 'Money makes money.',
    baseCost: { stone: 28000, gold: 20000, gems: 3200 },
    baseProduction: { gold: 16.8 },
    unlockCondition: { tech: 'banking' },
  },
};

export default TIER_07_BUILDINGS;
